/* global axios */

const baseURL = accountId =>
  `/api/v1/accounts/${accountId}/delfos_notifications`;

export default {
  getConfiguration(accountId, deviceId) {
    return axios.get(baseURL(accountId), {
      params: { device_id: deviceId },
    });
  },
  getPending(accountId) {
    return axios.get(`${baseURL(accountId)}/pending`);
  },
  heartbeat(accountId, payload) {
    return axios.post(`${baseURL(accountId)}/heartbeat`, payload);
  },
  releasePresence(accountId, payload) {
    return axios.delete(`${baseURL(accountId)}/heartbeat`, {
      data: payload,
    });
  },
  test(accountId, deviceId) {
    return axios.post(`${baseURL(accountId)}/test`, {
      device_id: deviceId,
    });
  },
};
